import type React from 'react';
import { useEffect, useRef, useState } from 'react';

// Components
import Carousel from 'app/shared/components/Carousel';

import * as S from './styles';
import getTiles from './Items';

import type { CardProps, SpacingMixinProps } from '@zillow/constellation';

const UpsellCarouselModule: React.FunctionComponent<
  React.PropsWithChildren<React.PropsWithChildren<CardProps & SpacingMixinProps>>
> = (props) => {
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);
  const AUTO_SCROLL_SPEED = 10 * 1000;
  const AUTO_SCROLL_PAUSE_DURATION = 30 * 1000;

  const updateWidth = () => {
    const containerObj = (containerRef && containerRef.current) || {
      offsetWidth: 1220,
    };

    setWidth(containerObj.offsetWidth);
  };

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  const ZrmUpsellItems = getTiles();

  return (
    <S.Container cardType="secondary" ref={containerRef} {...props}>
      <Carousel
        width={width}
        items={ZrmUpsellItems}
        autoScrollSpeed={AUTO_SCROLL_SPEED}
        autoScrollPauseDuration={AUTO_SCROLL_PAUSE_DURATION}
      />
    </S.Container>
  );
};

export default UpsellCarouselModule;
